import script from "./UserPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPermissions.vue?vue&type=script&setup=true&lang=js"

import "./UserPermissions.vue?vue&type=style&index=0&id=301361d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-301361d2"]])

export default __exports__